export default __webpack_public_path__ + "images/shopify_collapse.svg";